import React from 'react';
import type { UIMessage } from '@ai-sdk/react';
import { Button } from './ui/button';
import { Copy, ThumbsUp, ThumbsDown, RotateCcw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MessageActionsProps {
  message: UIMessage;
  content: string;
  onCopy?: () => void;
  onRegenerate?: () => void;
  onVote?: (vote: 'up' | 'down') => void;
  className?: string;
}

export function MessageActions({
  content,
  onCopy,
  onRegenerate,
  onVote,
  className,
}: MessageActionsProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    onCopy?.();
  };

  return (
    <div
      className={cn(
        'flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity',
        className
      )}
    >
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        onClick={handleCopy}
        title="Copy message"
      >
        <Copy className="w-3.5 h-3.5" />
      </Button>

      {onRegenerate && (
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          onClick={onRegenerate}
          title="Regenerate response"
        >
          <RotateCcw className="w-3.5 h-3.5" />
        </Button>
      )}

      {onVote && (
        <>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={() => onVote('up')}
            title="Good response"
          >
            <ThumbsUp className="w-3.5 h-3.5" />
          </Button>

          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={() => onVote('down')}
            title="Bad response"
          >
            <ThumbsDown className="w-3.5 h-3.5" />
          </Button>
        </>
      )}
    </div>
  );
}
